module.exports = __webpack_public_path__ + "bd4a05e9802288f7f677c50049b87069.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/basements_thumb.jpg
// module id = 477
// module chunks = 0